import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const WhatToWatch: Site = {
  id: 'whattowatch',
  logo: 'svg/whattowatch.svg',
  label: 'What to watch',
  analyticsName: 'whattowatch',
  hostname: 'whattowatch.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
